module.exports = __webpack_public_path__ + "img/adminServiceInfo3.6fd55c05.png";